import { Mic, MicOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface MicrophoneButtonProps {
  isListening: boolean;
  onStartListening: () => void;
  onStopListening: () => void;
  size?: "sm" | "default" | "lg";
  className?: string;
  compact?: boolean;
}

export function MicrophoneButton({
  isListening,
  onStartListening,
  onStopListening,
  size = "default",
  className,
  compact = false,
}: MicrophoneButtonProps) {
  const handleClick = () => {
    if (isListening) {
      onStopListening();
    } else {
      onStartListening();
    }
  };

  const iconSize = compact ? "h-3 w-3" : size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <Button
      size={compact ? "icon" : size === "sm" ? "sm" : "default"}
      variant={isListening ? "default" : "ghost"}
      onClick={handleClick}
      className={cn(
        "shrink-0",
        isListening && "bg-destructive hover:bg-destructive/90 text-destructive-foreground",
        compact && "h-7 w-7 p-0",
        className
      )}
      type="button"
      title={isListening ? "Arrêter l'enregistrement" : "Démarrer l'enregistrement vocal"}
    >
      {isListening ? <MicOff className={iconSize} /> : <Mic className={iconSize} />}
    </Button>
  );
}
